import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid, Text, Flex } from '@chatterbug/aaron'

const InfoCardSkeleton = ({
  titleSection,
  descriptionSection,
  imageSection,
  actionSection,
}) => {
  return (
    <Grid
      gridTemplateColumns={{ _: '100%', tablet: '446px 1fr' }}
      backgroundColor="white100"
      borderRadius="1x"
      boxShadow="raised"
      p={{ _: '3x', tablet: '5x' }}
    >
      {/* Text and Button */}
      <Flex
        flexDirection="column"
        mr={{ _: 0, tablet: '3x' }}
        mt="3x"
        gridRow={{ _: '2 / span 1', tablet: 'auto' }}
      >
        <Box as="h3" variant="text.h3" mb="2x">
          {titleSection}
        </Box>
        <Text mb="4x">{descriptionSection}</Text>
        {actionSection}
      </Flex>
      {/* Image */}
      {imageSection}
    </Grid>
  )
}

InfoCardSkeleton.propTypes = {
  titleSection: PropTypes.any,
  descriptionSection: PropTypes.any,
  imageSection: PropTypes.any,
  actionSection: PropTypes.any,
}

export default InfoCardSkeleton
